import { Inject } from "inversify-props";
import { AxiosPromise } from "axios";

import { AbpApplicationConfigurationApi } from "@/api";
import { ApplicationConfigurationDto } from "@/api/model";

export default interface IAppConfigService {
  getApplicationConfiguration(): AxiosPromise<ApplicationConfigurationDto>;
}

export class AppConfigService implements IAppConfigService {
  @Inject()
  private readonly abpApplicationConfigurationApi!: AbpApplicationConfigurationApi;

  public getApplicationConfiguration(): AxiosPromise<ApplicationConfigurationDto> {
    return this.abpApplicationConfigurationApi.apiAbpApplicationConfigurationGet();
  }
}
